enum EApplication {
  ALL_PRODUCTS = 'all_products',
  EVERY_PRODUCTS = 'every_products',
}

export default EApplication;
